export const SLIDER_AUTOPLAY_DELAY_MS = 2000;
